module.exports = __webpack_public_path__ + "assets/dienst4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/documentation/images/dienst4.jpg
// module id = 360
// module chunks = 0